// Here we define the state and it's validator function

import {
  daysAgo,
  isoDate,
  copyFromFactual,
  copyFromRegistered,
  copyContactPerson,
  copyContactPersonEmailPhone, residenceCopyFromRegistered, residenceCopyFromFactual,
  accountantCopyContactPerson,
  accountantCopyContactEmailPhone,
  accountantCopyHeadPerson,
} from './utils/helpers'
import { loadState, resetLocalStorage } from './local-storage'
import { Recommendation, Proxies, errorFiles, SocialLink, Messenger, Rentals } from './types/common-types'
import { COUNTRY } from './server-parameters'
import { FamilyStatus } from './enums/familyStatusEnum'
import { SoleTraderType } from './enums/fiscalTypeEnum'
import { AdditionalDocumentType } from './enums/additionalDocumentTypeEnum'
import { FoundingDocument } from './enums/foundingDocumentEnum'

export const STATE_REVISION = '1'

export const profileType_Physical = 'Physical'
export const profileType_Fiscal = 'Fiscal'

/*
  In order to add new state value we need to do four things:
  1) Add type definition to the State interface
  2) Add initial value to the INITIAL_STATE
  3) Add new action to the actions
  4) Add new case handling to the reducer
*/

// Define state for all inputs
/* STATE INTERFACE */
export interface State {
  [key: string]:
    | string
    | string[]
    | boolean
    | Recommendation[]
    | Proxies[]
    | number
    | null
    | object[]
    | errorFiles[]
  agreedCheck: boolean
  agreedCheck1: boolean
  agreedCheck2: boolean
  agreedCheck3: boolean
  iframeCountry: string
  currentStep: number
  revision: string
  createdAt: string
  formId: string
  userId: string
  orderId: string
  agreed: boolean
  passportType: string
  citizenship: string
  mainCity: string
  locale: string
  sex: string
  familyStatus: string
  firstName: string
  lastName: string
  patronymic: string
  latinFirstname: string
  latinLastname: string
  latinPatronymic: string
  noPatronymic: boolean
  noPatronymicContact: boolean
  isPhoneOk: boolean
  isEmailOk: boolean
  isIdentityOk: boolean
  birthDate: string
  birthPlace: string
  passportIAt: string
  passportExpiryDate: string
  passportSeries: string
  passportNumber: string
  headProxyNumber: string
  headProxyStart: string
  headProxyEnd: string
  passportPersonNumber: string
  taxIdentifier:string
  passportCardNumber: string
  passportFirstNationality: string
  passportIssuedBy: string
  passportAuthorityCode: string
  passportInternationalNumber: string
  passportPermanentResidencyNumber: string
  passportDateBoardCrossing: string
  passportDateBoardCheck: boolean | null
  passportDateIssuePermanentResidency: string
  passportIsPermanentResidency: boolean | null
  addressRegisteredDate: string
  addressRegisteredCountry: string
  addressRegisteredRegion: string
  addressRegisteredCity: string
  addressRegisteredStreet: string
  addressRegisteredAddressInRow: string
  addressRegisteredBuilding: string
  addressRegisteredBuildingBlock: string
  addressRegisteredPremises: string
  addressRegisteredFloor: string
  addressRegisteredOffice: string
  addressRegisteredApartments: string
  addressFactualCopyFromRegistered: boolean
  copyContactPerson: boolean
  copyContactPersonEmailPhone: boolean
  accountantCopyContactPerson: boolean
  accountantCopyHeadPerson: boolean
  accountantCopyContactEmailPhone: boolean
  addressFactualCountry: string
  addressFactualRegion: string
  addressFactualCity: string
  addressFactualStreet: string
  addressFactualBuilding: string
  addressFactualBuildingBlock: string
  addressFactualPremises: string
  addressFactualFloor: string
  addressFactualOffice: string
  addressFactualApartments: string
  addressResidenceCountry: string
  addressResidenceRegion: string
  addressResidenceCity: string
  addressResidenceStreet: string
  addressResidenceBuilding: string
  addressResidenceBuildingBlock: string
  addressResidencePremises: string
  addressResidenceFloor: string
  addressResidenceOffice: string
  addressResidenceApartments: string
  addressResidencePostCode: string
  addressResidenceCopyFromRegistered: boolean
  addressResidenceCopyFromFactual: boolean
  passportImages: string[]
  documentsImages: []
  mainImageFile: string[]
  personImageFile: string[]
  residenceImageFile: string[]
  additionalDocumentType: string
  secondAdditionalDocumentType: string
  additionalDocumentDateExpiry: string
  secondAdditionalDocumentDateExpiry: string
  documentsPhotoOne: string[]
  documentsPhotoTwo: string[]
  addressFactualAddressInRow: string
  addressImageFile: string[]
  visaImageFile: string[]
  portfolioImages: string[]
  mobilePhoneNumbers: string[]
  addressRegisteredPhones: string[]
  addressFactualPhones: string[]
  workPhoneNumbers: string[]
  emails: string[]
  socialLink: string
  messengers: Messenger[];
  rentalsCheck: boolean;
  rentals: Rentals[];
  preferredCommunicationType: string
  preferredCommunicationTime: string
  additionalLinksDescription: string[]
  occupationType: string
  occupationInstitution: string
  occupationPosition: string
  monthlyIncome: string
  isStudent: boolean
  collegeName: string
  collegeProfession: string
  collegeStartedAt: string
  additionalDocumentComment: string
  secondAdditionalDocumentComment: string
  isAdditionalDocumentPerpetual: boolean
  isSecondAdditionalDocumentPerpetual: boolean
  collegeEndedAt: string
  recommendations: string
  references: string[]
  rentStartedAt: string
  rentEndedAt: string
  goods: []
  vk: string[]
  whatsapp: string[]
  odnoklassniki: string[]
  facebook: string[]
  telegram: string[]
  youtube: string[]
  viber: string[]
  vimeo: string[]
  twitter: string[]
  skype: string[]
  instagram: string[]
  workWebsite: string[]
  personalWebsite: string[]
  additionalLinks: string[]
  subscribe: boolean
  feedback: string
  agreedOn: string[]
  profileType: string
  telegramCheck: boolean
  whatsappCheck: boolean
  viberCheck: boolean

  //Fiscal
  countryRegistration: string
  vatCertificate: string
  certificateRegistrationNumber: string
  reregistrationCertificate: string
  reregisteredDate: string
  VatCertificateDate: string
  oKED: string
  F_INN: string
  F_KBe: string
  F_KPP: string
  F_FiscalType: string
  soleTraderType: string
  registrationTicket: string
  registrationNotice: string
  scanSoleRegistrationTicket: string[]
  scanSoleRegistrationTicketSecond: string[]
  scanOfNotificationFirst: string[]
  scanOfNotificationSecond: string[]
  F_FullName: string
  noFullName: boolean
  F_ShortName: string
  F_OGRN: string
  F_OGRNIP: string
  oKPO: string
  F_OKATO: string
  F_OKOPF: string
  F_addressRegistered: string
  F_addressFactual: string
  BankDetails: object[]
  // F_BankRS: string
  // F_BankBIK: string
  // F_BankName: string
  // F_BankKS: string
  F_TaxType: string
  F_Website: string
  F_Contact: string
  contactPersonPhones: string[]
  contactPersonEmails: string[]
  contactPersonPosition: string
  contactPersonFirstname: string
  contactPersonLastname: string
  contactPersonPatronymic: string
  accountantPersonPhones: string[]
  accountantPersonEmails: string[]
  accountantPersonPosition: string
  accountantPersonFirstname: string
  accountantPersonLastname: string
  accountantPersonPatronymic: string
  // F_WorkPhoneNumber: string[]
  F_ContactPhoneNumber: string[]
  // F_Email: string[]
  // F_Contact_Email: string[]
  F_DocImages: string[]
  F_OGRN_Image: string[]
  F_OGRNIP_Image: string[]
  F_INN_Image: string[]
  F_Charter_Image: string[]
  F_Protocol_Image: string[]
  F_EGRUL_Image: string[]
  F_Order_Image: string[]
  F_Passport_Director_Image: string[]
  F_Rent_Contract_Image: string[]
  noLeaseAgreement: boolean
  addressRegisteredNoApartments: boolean
  addressFactualNoApartments: boolean
  F_ContactsProxie: string

  F_Directors_Phone: string[]
  contactPhones: string[]
  contactPhoneSeconds: string[]
  contactEmails: string[]
  purposeOfLease: string
  F_Proxies_Phone: string[]
  F_Proxies_FullName: string
  F_Directors_FullName: string
  headFirstname: string
  headLastname: string
  headPatronymic: string
  headFirstnameIp: string
  headLastnameIp: string
  headPatronymicIp: string
  headFirstnameGenitive: string
  headLastnameGenitive: string
  headPatronymicGenitive: string
  F_Scan_Directors_Passport: string[]
  F_Scan_Directors_Passport_Address: string[]
  registeredDate: string
  registrationNoticeDate: string
  receptionNoticeDate: string
  stateRegistrationCertificate: string[]
  headPosition: string
  headPositionGenitive: string
  foundingDocument: string
  foundingDocument_Image: string[]
  F_Ip_FullName: string
  F_Booker: string
  F_Directors_Email: string[]
  F_Proxies_Passport_ImageFile: string[]
  F_Proxies_Order_ImageFile: string[]
  addressFactualPostCode: string
  addressRegisteredPostCode: string
  F_Proxies: Proxies[]
  F_ProxiesOn: boolean

  Confirm_phone: string
  Confirm_phone_ok: boolean
  Confirm_mail: string
  Confirm_mail_ok: boolean
  imageError: errorFiles[]
  serverError: boolean
}

export const INITIAL_STATE: State = {
  iframeCountry: COUNTRY,
  currentStep: 0,
  createdAt: isoDate(new Date()),
  revision: STATE_REVISION,
  formId: '',
  userId: '',
  orderId: '',
  agreedCheck: false,
  agreedCheck1: false,
  agreedCheck2: false,
  agreedCheck3: false,
  agreed: false,
  passportType: '',
  citizenship: COUNTRY === 'kz' ? '398' : '643',
  mainCity: '',
  locale: 'RU',
  sex: '0',
  familyStatus: String(FamilyStatus.NotSelected),
  firstName: '',
  lastName: '',
  patronymic: '',
  latinFirstname: '',
  latinLastname: '',
  latinPatronymic: '',
  noPatronymic: false,
  noPatronymicContact: false,
  isPhoneOk: true,
  isEmailOk: true,
  passportSeries: '',
  passportNumber: '',
  headProxyNumber: '',
  headProxyStart: '',
  headProxyEnd: '',
  passportPersonNumber: '',
  taxIdentifier: '',
  passportCardNumber: '',
  passportFirstNationality: '',
  passportIAt: '',
  passportExpiryDate: '',
  birthDate: '',
  birthPlace: '',
  passportIssuedBy: '',
  passportAuthorityCode: '',
  passportInternationalNumber: '',
  passportPermanentResidencyNumber: '',
  passportDateBoardCrossing: '',
  passportDateBoardCheck: false,
  passportDateIssuePermanentResidency: '',
  passportIsPermanentResidency: null,
  passportIsScaned: false,
  addressRegisteredDate: '',
  stateRegistrationCertificate: [],
  addressRegisteredCountry: COUNTRY === 'kz' ? '398' : '643',
  addressRegisteredRegion: '',
  addressRegisteredCity: '',
  addressRegisteredStreet: '',
  addressRegisteredAddressInRow: '',
  addressRegisteredBuilding: '',
  addressRegisteredBuildingBlock: '',
  addressRegisteredPremises: '',
  addressRegisteredFloor: '',
  addressRegisteredOffice: '',
  addressRegisteredApartments: '',
  addressFactualCopyFromRegistered: false,
  copyContactPerson: false,
  copyContactPersonEmailPhone: false,
  accountantCopyContactPerson: false,
  accountantCopyHeadPerson: false,
  accountantCopyContactEmailPhone: false,
  addressFactualCountry: COUNTRY === 'kz' ? '398' : '643',
  addressFactualRegion: '',
  addressFactualCity: '',
  addressFactualStreet: '',
  addressFactualBuilding: '',
  addressFactualBuildingBlock: '',
  addressFactualPremises: '',
  addressFactualFloor: '',
  addressFactualOffice: '',
  addressFactualApartments: '',
  addressResidenceCountry: COUNTRY === 'kz' ? '398' : '643',
  addressResidenceRegion: '',
  addressResidenceCity: '',
  addressResidenceStreet: '',
  addressResidenceBuilding: '',
  addressResidenceBuildingBlock: '',
  addressResidencePremises: '',
  addressResidenceFloor: '',
  addressResidenceOffice: '',
  addressResidenceApartments: '',
  addressResidencePostCode: '',
  addressResidenceCopyFromRegistered: false,
  addressResidenceCopyFromFactual: false,
  passportImages: [],
  documentsImages: [],
  mainImageFile: [],
  personImageFile: [],
  residenceImageFile: [],
  additionalDocumentType: '',
  secondAdditionalDocumentType: String(AdditionalDocumentType.NotSelected),
  additionalDocumentDateExpiry: '',
  secondAdditionalDocumentDateExpiry: '',
  documentsPhotoOne: [],
  documentsPhotoTwo: [],
  addressFactualAddressInRow: '',
  addressImageFile: [],
  visaImageFile: [],
  portfolioImages: [],
  mobilePhoneNumbers: [],
  addressRegisteredPhones: [],
  addressFactualPhones: [],
  workPhoneNumbers: [],
  emails: [],
  socialLink: '',
  messengers: [],
  rentals: [],
  rentalsCheck: false,
  preferredCommunicationType: '',
  preferredCommunicationTime: '',
  additionalLinksDescription: [],
  occupationType: '',
  occupationInstitution: '',
  occupationPosition: '',
  monthlyIncome: '',
  isStudent: false,
  collegeName: '',
  collegeProfession: '',
  collegeStartedAt: '',
  additionalDocumentComment: '',
  secondAdditionalDocumentComment: '',
  isAdditionalDocumentPerpetual: false,
  isSecondAdditionalDocumentPerpetual: false,
  collegeEndedAt: '',
  recommendations: '',
  references: [],
  rentStartedAt: '',
  rentEndedAt: '',
  goods: [],
  vk: [],
  whatsapp: [],
  odnoklassniki: [],
  facebook: [],
  telegram: [],
  youtube: [],
  vimeo: [],
  viber: [],
  twitter: [],
  skype: [],
  instagram: [],
  workWebsite: [],
  personalWebsite: [],
  additionalLinks: [],
  subscribe: false,
  feedback: '',
  agreedOn: [],
  profileType: '',
  telegramCheck: false,
  whatsappCheck: false,
  viberCheck: false,

  //Fiscal
  countryRegistration: (COUNTRY === 'kz') ? '398' : '643',
  vatCertificate: '',
  certificateRegistrationNumber: '',
  reregistrationCertificate: '',
  reregisteredDate: '',
  VatCertificateDate: '',
  oKED: '',
  F_INN: '',
  F_KBe: '',
  F_KPP: '',
  F_FiscalType: '',
  soleTraderType: String(SoleTraderType.NewStyle),
  registrationTicket: '',
  scanSoleRegistrationTicket: [],
  scanSoleRegistrationTicketSecond: [],
  registrationNotice: '',
  scanOfNotificationFirst: [],
  scanOfNotificationSecond: [],
  F_FullName: '',
  noFullName: false,
  F_ShortName: '',
  F_OGRN: '',
  F_OGRNIP: '',
  oKPO: '',
  F_OKATO: '',
  F_OKOPF: '',
  F_addressRegistered: '',
  F_addressFactual: '',
  BankDetails: [
    {
      F_BankBIK: '',
      F_BankName: '',
      F_BankRS: '',
      F_BankKS: '',
      F_BankRNN: '',
      F_BankBIN: '',
      F_BankKBe: '',
    },
  ],
  // F_BankRS: '',
  // F_BankBIK: '',
  // F_BankName: '',
  // F_BankKS: '',
  F_TaxType: '0',
  F_Website: '',
  F_Contact: '',
  contactPersonPhones: [],
  contactPersonEmails: [],
  contactPersonPosition: '',
  contactPersonFirstname: '',
  contactPersonLastname: '',
  contactPersonPatronymic: '',
  accountantPersonPhones: [],
  accountantPersonEmails: [],
  accountantPersonPosition: '',
  accountantPersonFirstname: '',
  accountantPersonLastname: '',
  accountantPersonPatronymic: '',
  // F_WorkPhoneNumber: [],
  F_ContactPhoneNumber: [],
  // F_Email: [],
  // F_Contact_Email: [],
  F_DocImages: [],
  F_OGRN_Image: [],
  F_OGRNIP_Image: [],
  F_INN_Image: [],
  F_Charter_Image: [],
  F_Protocol_Image: [],
  F_EGRUL_Image: [],
  F_Order_Image: [],
  F_Passport_Director_Image: [],
  F_Rent_Contract_Image: [],
  noLeaseAgreement: false,
  addressRegisteredNoApartments: false,
  addressFactualNoApartments: false,
  F_ContactsProxie: '',
  F_Directors_Phone: [],
  contactPhones: [],
  contactPhoneSeconds: [],
  contactEmails: [],
  purposeOfLease: '',
  F_Directors_FullName: '',
  headFirstname: '',
  headLastname: '',
  headPatronymic: '',
  headFirstnameIp: '',
  headLastnameIp: '',
  headPatronymicIp: '',
  headFirstnameGenitive: '',
  headLastnameGenitive: '',
  headPatronymicGenitive: '',
  headPosition: '',
  headPositionGenitive: '',
  foundingDocument: String(FoundingDocument.NotSelected),
  F_Scan_Directors_Passport: [],
  F_Scan_Directors_Passport_Address: [],
  registeredDate: '',
  registrationNoticeDate: '',
  receptionNoticeDate: '',
  foundingDocument_Image: [],
  F_Booker: '',
  F_Proxies_Phone: [],
  F_Proxies_FullName: '',
  F_Ip_FullName: '',
  F_Directors_Email: [],
  F_Proxies_Passport_ImageFile: [],
  F_Proxies_Order_ImageFile: [],
  addressFactualPostCode: '',
  addressRegisteredPostCode: '',

  F_Proxies: [],
  F_ProxiesOn: true,

  Confirm_phone: '',
  Confirm_phone_ok: false,
  Confirm_mail: '',
  Confirm_mail_ok: false,
  isIdentityOk: true,
  imageError: [],
  serverError: false
}

export function getInitialState(localStorage: Storage): State {
  const savedState = loadState(INITIAL_STATE, localStorage)
  const weekAgo = daysAgo(7)
  // Earlier than
  if (new Date(savedState.createdAt) < weekAgo) {
    resetLocalStorage(localStorage)
    return INITIAL_STATE
  }
  return {
    ...savedState,
    currentStep: 0,
  }
}
